
define('jst!tooltips/_headline_subline',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if (data.headline) { %>\n  <div class="headline"><%= data.headline %></div>\n<% } %>\n\n<% if (data.subline) { %>\n  <div class="subline"><%= data.subline %></div>\n<% } %>\n');
 });

